import { RoomDiscount } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Title, List, Item } from '../common/layout'

const ROOM_DISCOUNTS = [
  {
    title: '장기 계약 할인',
    value: RoomDiscount.LONG_TERM,
  },
  {
    title: '즉시 입주 할인',
    value: RoomDiscount.EARLY,
  },
]

type Props = {
  className?: string
}

export const RoomDiscounts = ({ className }: Props) => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { roomDiscounts },
    updateFilter,
  } = useFilter()

  const handleRoomDiscountChange = (value: RoomDiscount) => () => {
    updateFilter({ roomDiscounts: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.RoomDiscounts, element)
        }
      }}
    >
      <Title>할인</Title>
      <List>
        {ROOM_DISCOUNTS.map(({ title, value }) => (
          <Item
            key={value}
            type={type}
            selected={roomDiscounts.includes(value)}
            onClick={handleRoomDiscountChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
